import { Button, Text, Tooltip, type ButtonProps } from '@chakra-ui/react';
import { useEffect, useRef, useState, type FC } from 'react';

interface OverflowButtonProps extends ButtonProps {
  hideTextOnOverflow?: boolean;
}

export const OverflowButton: FC<OverflowButtonProps> = ({
  hideTextOnOverflow = false,
  children,
  ...props
}) => {
  const [hasOverflow, setHasOverflow] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const checkOverflow = () => {
      if (textRef.current) {
        setHasOverflow(
          textRef.current.scrollWidth > textRef.current.clientWidth,
        );
      }
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [children]);

  return (
    <Tooltip
      w='full'
      fontSize='xs'
      border='1px solid'
      borderColor='border'
      label={hasOverflow ? children : ''}
      placement='top'
    >
      <Button
        {...props}
        iconSpacing={!hideTextOnOverflow || !hasOverflow ? '2' : '0'}
      >
        {(!hideTextOnOverflow || !hasOverflow) && (
          <Text
            ref={textRef}
            as='span'
            overflow='hidden'
            whiteSpace='nowrap'
            textOverflow='ellipsis'
          >
            {children}
          </Text>
        )}
      </Button>
    </Tooltip>
  );
};
